
import {useEffect, useState} from "react";
import _ from "lodash";
import type {DaoCategory} from "../../daos/dao-category.ts";

interface MenuAnnounceProps {
  callback?: (menu: DaoCategory) => void;
}

function MenuAnnounce({callback}: MenuAnnounceProps) {
  const menus: DaoCategory[] = [{no: 'schedule', name: '편성표'}, {no: 'common', name: '일반'}, {no: 'celebrate', name: '축하'}];
  const [announce, setAnnounce] = useState<DaoCategory>();

  function announceChangeHandler(menu: DaoCategory): void {
    if(!_.isEqual(menu, announce)) {
      setAnnounce(menu);
      if(_.isFunction(callback)) {
        callback.call(null, menu);
      }
    }
  }

  useEffect(() => {
    if (menus.length > 0) {
      announceChangeHandler(menus[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="category">
      <div className="category-list">
        {menus.map((item: DaoCategory) => (
          <div className="category-item" key={item.no}><a onClick={() => announceChangeHandler(item)} className={(announce && _.isEqual(announce.no, item.no)) ? 'on' : ''}>{item.name}</a></div>
        ))}
      </div>
    </div>
  );
}

export default MenuAnnounce;